import SignupComponent from "../components/SignupComponent";

export default function Signup() {
    return (
      <>
        <SignupComponent />
      </>
    );
}